import {
    DossierDetailsContent,
    DossierDetailsHeader,
    DossierDetailsPanel,
    DossierDetailsView,
} from "@/app/pages/dossier/dossier-details-panel";
import { TvvBesteldeRoute, useGetTvvBesteldeRoutes } from "@/entities/tvv";
import { TvvDetailsSkeleton } from "@/features/tvv/components/shared";
import { Empty, EmptyDescription, EmptyHeader, EmptyImage, EmptyTitle } from "@/shared/components/ui";
import { useSearchParams } from "react-router";
import { RegieCentrumBussenRouteItem } from "./regiecentrumbussen-route-item";

type TvvDetailsRegieCentrumBussenProps = {
    dossierId: string;
};

export function TvvDetailsRegieCentrumBussen({ dossierId }: Readonly<TvvDetailsRegieCentrumBussenProps>) {
    // Don't include OV routes in RCB view as there is nothing to do for RCB
    const query = useGetTvvBesteldeRoutes(dossierId, { select: (routes) => routes.filter((r) => !r.isOvRoute) });

    return (
        <DossierDetailsView section="Tvv" query={query} skeleton={<TvvDetailsSkeleton />} errorTitle="Fout bij het laden van TVV routes">
            {(routes) => <TvvDetailsRegieCentrumBussenContent dossierId={dossierId} routes={routes} />}
        </DossierDetailsView>
    );
}

type TvvDetailsRegieCentrumBussenContentProps = {
    dossierId: string;
    routes: TvvBesteldeRoute[];
};

function TvvDetailsRegieCentrumBussenContent({ dossierId, routes }: Readonly<TvvDetailsRegieCentrumBussenContentProps>) {
    const [searchParams] = useSearchParams();
    const preselectedRouteId = searchParams.get("routeId");

    if (routes.length === 0) {
        return (
            <DossierDetailsPanel>
                <DossierDetailsHeader section="Tvv" showBackButton />
                <DossierDetailsContent>
                    <Empty>
                        <EmptyHeader>
                            <EmptyImage />
                            <EmptyTitle>Geen routes beschikbaar</EmptyTitle>
                            <EmptyDescription>Er zijn nog geen TVV routes aangevraagd voor dit dossier.</EmptyDescription>
                        </EmptyHeader>
                    </Empty>
                </DossierDetailsContent>
            </DossierDetailsPanel>
        );
    }

    return (
        <DossierDetailsPanel>
            <DossierDetailsHeader section="Tvv" showBackButton />
            <DossierDetailsContent className="space-y-4">
                <ul className="flex flex-col" role="list">
                    {routes.map((route) => {
                        const defaultOpen = preselectedRouteId ? Number(preselectedRouteId) === route.id : true;
                        return (
                            <RegieCentrumBussenRouteItem
                                key={`${route.id}-${defaultOpen}`}
                                route={route}
                                dossierId={dossierId}
                                defaultOpen={defaultOpen}
                            />
                        );
                    })}
                </ul>
            </DossierDetailsContent>
        </DossierDetailsPanel>
    );
}
